// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swipe{display:flex;position:relative;transform-style:preserve-3d}.swipe-center{cursor:pointer;min-width:100%;transition:all .25s ease;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:3}.swipe-left{opacity:0;transform:translateX(-100%)}.swipe-right{opacity:0;transform:translateX(100%)}.actions{position:relative}.swipe-left,.swipe-right{left:0;position:absolute;top:0;transition:all .25s ease}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
